import React, { useEffect, useRef } from 'react';

const Maps: React.FC = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      const map = new google.maps.Map(ref.current, {
        center: new google.maps.LatLng(23.910618, 35.473275),
        zoom: 16,
        mapTypeId: 'satellite',
        draggable: false,
        streetViewControl: true,
      });
      const streetViewLayer = new google.maps.StreetViewCoverageLayer();
      streetViewLayer.setMap(map);
    }
  });

  return <div style={{ width: '100%', height: '600px' }} ref={ref} id="map" />;
};

export default Maps;
